import api from './client';

export const getHotels = () => api.get('/hotels/');
export const getHotel = (id: string) => api.get(`/hotels/${id}/`);
export const createHotel = (data: any) => api.post('/hotels/', data);
export const updateHotel = (id: string, data: any) => api.patch(`/hotels/${id}/`, data);
export const getRooms = (hotelId: string) => api.get(`/hotels/${hotelId}/rooms/`);
export const createRoom = (hotelId: string, data: any) => api.post(`/hotels/${hotelId}/rooms/`, data);
export const getHotelAgents = (hotelId: string) => api.get(`/hotels/${hotelId}/agents/`);
export const addHotelAgent = (hotelId: string, data: any) => api.post(`/hotels/${hotelId}/agents/`, data);
export const getRatePlans = (hotelId: string) => api.get(`/hotels/${hotelId}/rate-plans/`);
